import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { deleteExpressParams, getExpressParams } from '../../../service/api';

import CustomManagerMain from '../../presentation/section/custom-manager-page/CustomManagerMain';

const CustomManager = (props) => {
  const [selectedCustom, setSelectedCustom] = useState({
    customID: null,
    name: null,
    label: null
  });

  const [customLabelData, setCustomLabelData] = useState({
    type: null,
    name: null,
    info: [],
    nullLabelItem: [],
    nullLabelItemType: null
  })

  const [customFilter, setCustomFilter] = useState('');
  const [filteredArray, setFilteredArray] = useState({
    type: null,
    name: null,
    info: [],
    nullLabelItem: [],
    nullLabelItemType: null
  })

  const [selectedCustomQueryArray, setSelectedCustomQueryArray] = useState([]);
  const [queryData, setQueryData] = useState(null);

  useEffect(()=>{
    getExpressParams('/query/custom-label/userid/all', {
      email: props.currentUser
    }, (response) => {
      setCustomLabelData(MakeLabelTreeData(response.data.customentity, response.data.BuzzLabel));
      setQueryData(response.data.queryentity);
    })
  },[])

  useEffect(() => {
  }, [selectedCustomQueryArray])

  useEffect(() => {
    if (!selectedCustom.customID) {

    }
    else {
      getSelectedCustomInfo(selectedCustom.customID)
    }
  }, [selectedCustom])

  useEffect(()=>{
    handleSearchBtn(JSON.stringify(customLabelData));
  }, [customLabelData])

  const handleSelectedCustom = (customInfo) => {

    setSelectedCustom({
      customID: customInfo.customID,
      name: customInfo.name,
      label: customInfo.label
    })
  }

  const getSelectedCustomInfo = ( customID ) => {
    // setSelectedCustomQueryArray([])
    getExpressParams('/query/custom-content/userid/customid', {
      email: props.currentUser,
      customID: customID
    }, (response) => {
      setSelectedCustomQueryArray(response.data.customentity.map(item=>item));
    })
  }

  const handleSearchInput = (event) => {
    setCustomFilter(event.target.value);
  }

  const MakeLabelTreeData = (nodeData, labelData) => {
    let retLabelTreeData = labelData;
    retLabelTreeData.nullLabelItemType = nodeData.type;
    retLabelTreeData.nullLabelItem = [];
    retLabelTreeData.info.forEach((item,index)=> {
      item.labelItem = [];
      // item.checked = false;
      nodeData.info.filter((filteredNode)=>filteredNode.label==item.labelID).forEach(
        (filteredItem, index) => {
          let pushItem = filteredItem;
          // pushItem.checked = false;
          item.labelItem.push(pushItem);
          item.labelItemType = nodeData.type;
      })
    })
    nodeData.info.filter((filteredNode) => filteredNode.label==null).forEach(
      (item)=>{
        let pushItem = item;
        // pushItem.checked = false;
        retLabelTreeData.nullLabelItem.push(pushItem);
      }
    );
    return retLabelTreeData;
  }

  const handleSearchBtn = (originArray) => {
    let tempArray = JSON.parse(originArray);
    tempArray.nullLabelItem = tempArray.nullLabelItem.filter((item)=>!customFilter || item.name.toLowerCase().startsWith(customFilter.toLowerCase()));

    tempArray.info.forEach(
      (item) => {
        item.labelItem = item.labelItem.filter((customItem)=> !customFilter || customItem.name.toLowerCase().startsWith(customFilter.toLowerCase()));
      }
    )
    tempArray.info = tempArray.info.filter(
      ((item)=>item.labelItem.length > 0)
    );
    
    setFilteredArray(tempArray);
    // setResultData(null);
  }

  const handleRemoveBtn = (customID) => {
    deleteExpressParams(`/query/custom-content/customid`, {
      email: props.currentUser,
      customID: customID
    }, (response) =>{
      setSelectedCustom({
        customID: null,
        name: null,
        label: null
      });
      setCustomLabelData({
        type: null,
        name: null,
        info: [],
        nullLabelItem: [],
        nullLabelItemType: null
      });
      
    })
  }

  return(
    <CustomManagerMain customLabelData={customLabelData} handleClick={handleSelectedCustom}
      handleSearchBtn={handleSearchBtn} customFilter={customFilter} handleSearchInput={handleSearchInput} filteredArray={filteredArray}
      selectedCustomQueryArray={selectedCustomQueryArray} selectedCustom={selectedCustom} queryData={queryData}
    />
  )
}

const mapStateToProps = (state) => ({
  currentUser: state.AuthManager.status.currentUser
})

export default connect(mapStateToProps) (CustomManager);